<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">

          <span class ="arch">
            <p>Each page I read I tells me more. Words become places and conjure memories, impart form to empty air.</p>
            <p>I know this place, hidden between lines and buried in the paragraphs on a page. </p>
            <p>I know it and I have lived it.</p>
            <p>I recognise the phrases and I have walked the streets those words describe. I have watched a funeral procession make its way into the harbour and cast the body toward the sea. </p>
            <p>I have waited for a secret humdrum to open, have queued in the rain, the never-ceasing rain for a single performance, you'd never want to leave. They'd drag you out of there with your bones shaking.</p>
            <p>I know that if this was my city, then it would be a place of such wonder.</p>
            <p>When you waved at the sky with your eyes wide open it would seem like the streets fell away behind you. </p>
            <p>You could walk the city from edge to edge and never be more than thirty feet from the sea. Sometimes even closer. Especially at tidefall.</p>
            <p>If you found the closter of the whale, you can be sure the kraken isn't far behind. </p>
            <p>If this was my city then I'd take you to the flowtunnels and we'd watch the river rise above the tideline and keep rising. The markers would float away and be lost, returned the next morning as good as new. </p>
            <p>In my city there's only water, and seashaws and the geese on the banks. </p>
            <p>This isn't my city and I can do none of those things.</p>
            <p>This isn't my city, but I can feel it, and see it in the alleyways and under the bridges. It sits between this one and another, squats between two places in the shadows and in the doorways. I see it when the lights come on, for a moment. A glimpse in the interstices of dawn, of somewhere else, not there and not here. </p>
            <p>There are half built spurs where plustens should soar above my head, there is a river meandering through your streets, not flooding, not drowning the unwary, but sitting like a funeral in the sun. </p>
            <p>There are crowds of people, none of whom have ever read a tradestream or walked the night looking for the market they found the night before. None of them. </p>
            <p>But neither have I. </p>
            <p>These words came to me and I can see them as bright as a morning. They sang to me, but I do not know what they describe, truly. </p>
            <p>I can see this city and it is not right. It is not as it should be. </p>
            <p></p>
            <p>Each page she finishes, I remember.</p>
            <p>Yet I am not in her words, </p>
            <p>am I forgotten so easily?</p>

            <p></p>
            <p>and if I write, will she see my words?</p>
            <p>I take a blank page in the book and I write down what I see here. I want to fix this, line by line, the things I remember, the things that my memory holds onto. </p>
            <p>If I write things down, if I write a word and strike it out, I am making a choice, I am building the city I want, and writing myself into it</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'If This Was My City'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
